import React, { Fragment, useState, useEffect, useRef, useContext } from 'react';
import { Btn, H4, P, Image, Alerts } from '../AbstractElements';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logoWhite from '../assets/images/logo/logo.png';
import logoDark from '../assets/images/logo/logo_dark.png';

import { EmailAddress, ForgotPassword, Password, RememberPassword, SignIn } from '../Constant';

//import { Jwt_token } from '../Config/Config';
import man from '../assets/images/dashboard/profile.png';
//import { handleResponse } from '../Services/fack.backend';

import useAuth from '../Hooks/useAuth';
import axios from '../api/axios';
//import useLocalStorage from '../Hooks/useLocalStorage';
import useToggle from '../Hooks/useToggle';
import Spinner from '../Components/Common/Component/Spinner';
import CustomizerContext from '../_helper/Customizer';
import TotpForm from './TotpForm';
import { useAppDispatch, useAppSelector } from '../redux/hooks/hook';
import { useLoginMutation } from '../redux/features/auth/authApiSlice';
import { selectCurrentUser, selectIs2FARequired, selectIs2FAValidated, set2FACredentials, setCredentials } from '../redux/features/auth/authSlice';
//import{ AuthResponse } from '../redux/features/auth/authType'
const LOGIN_URL = '/auth/login';
//import { useCookies } from "react-cookie";


//import QRCode from 'qrcode.react';

const LoginForm = ({ logoClassMain }) => {

  const { setAuth } = useAuth();
  //const [cookies, setCookie] = useCookies(["user"]);
  
  const [check, toggleCheck] = useToggle('persist', true);

  const navigate = useNavigate();
  const location = useLocation();
  //const from = location.state?.from?.pathname || "/";
  
  const userRef = useRef();
  const errRef = useRef();

  //const [loading, setLoading] = useState(false);
  const [authDetails, setAuthDetails] = useState(false);
  const [is2faEnabled, setIs2faEnabled] = useState(false);
  const [codeVerified, setCodeVerified] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [togglePassword, setTogglePassword] = useState(false);
  //const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const _2fa = `/authentication/enable-2fa/${layoutURL}`;
  const from = `/dashboard/default/${layoutURL}`;
  const [errMsg, setErrMsg] = useState('');

  const [value
    //, setValue
    ] = useState(localStorage.getItem('profileURL' || man));
  const [name, setName] = useState(localStorage.getItem('Guest')); 

    const [login, { isLoading }] = useLoginMutation()
    const currentUser = useAppSelector(selectCurrentUser)
    const is2FARequired = useAppSelector(selectIs2FARequired)
    const is2FAValidated = useAppSelector(selectIs2FAValidated)
    const dispatch = useAppDispatch()

  useEffect(() => {
    localStorage.setItem('profileURL', man);
    
    if(currentUser) {
      const name = `${currentUser.contact.last_name} ${currentUser.contact.first_name}`
      localStorage.setItem('Name', name);
    }
}, [value, currentUser]);

  useEffect(() => {
    if(userRef.current) {
      userRef.current.focus();
    }
  }, [])

  useEffect(() => {
      setErrMsg('');
  }, [email, password])

  useEffect(() => {
      if(currentUser && !is2FARequired){
        handleSetAuthDetails()
        navigate(_2fa, { replace: true });
      }
      
      if(currentUser && is2FARequired && is2FAValidated){
        handleSetAuthDetails()
        navigate(from, { replace: true });
      }

  }, [currentUser, is2FARequired, is2FAValidated])

 const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
        //setLoading(true); 
        /* const response = await axios.post(LOGIN_URL,
            JSON.stringify(`grant_type=&username=${email}&password=${password}&scope=&client_id=&client_secret=`),
          {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              withCredentials: true
          } 
        );
        
        setAuthDetails(response)
        setPassword('');
        setIs2faEnabled(response?.data?.user.is_2fa_enabled)
        */

        const response = await login({ email, password }).unwrap()
        dispatch(setCredentials({ user:response.user, accessToken:response.access_token })) 
        dispatch(set2FACredentials({is2FARequired: response?.user.is_2fa_enabled, is2FAValidated: false}))
        
        setAuthDetails(response)
        setPassword('');
        setIs2faEnabled(response?.user.is_2fa_enabled)

        localStorage.setItem('authenticated', true);

        /*  if(!response?.data?.user.is_2fa_enabled) {
          navigate(_2fa, { replace: true });
        } else {
           navigate(from, { replace: true });
        }*/
    } catch (err) {
        
        if (err?.status && err?.status === 400) {
            setErrMsg(err?.data?.detail);
        } else if (!err?.response) {
            setErrMsg('No Server Response');
        } else if (err.response?.status === 422) {
            setErrMsg('Missing Username or Password');
        } else if (err.response?.status === 401) {
            setErrMsg('Unauthorized');
        } else if (err.response && err.response.status === 400) {
            setErrMsg(err.response.data.detail);
        } else {
            setErrMsg('Login Failed');
        }
       // errRef.current.focus();
    } 
    /* finally {
      setLoading(false);
    } */
  }

  const handleSetAuthDetails = () => {

    /* const accessToken = authDetails?.data?.access_token;
    const refreshToken = authDetails?.data?.refresh_token;
    const expires_in = authDetails?.data?.expires_in;
    const roles = authDetails?.data?.roles;
    const user = authDetails?.data?.user; */
    let user;
    if(authDetails) {
      const accessToken = authDetails?.access_token;
      const refreshToken = authDetails?.refresh_token;
      const expires_in = authDetails?.expires_in;
      const roles = authDetails?.roles;
      user = authDetails?.user;

      setAuth({ user, email, roles, accessToken, refreshToken, expires_in }); 
    } else {
      user = currentUser;
      setAuth({ user, email:user.email });
    }
  }

  const handleCodeVerified = async (data) => { 
    if(data) { 
      setCodeVerified(true)
      dispatch(set2FACredentials({is2FARequired: true, is2FAValidated: true}))
    }
  }
  
/*   const togglePersist = () => {
    setPersist(prev => !prev);
  }

  useEffect(() => {
      localStorage.setItem("persist", persist);
  }, [persist]) */

  return (
    <Fragment>
      <div className='login-card'>
      <div>
          
            <div>
              <Link className={`logo ${logoClassMain ? logoClassMain : ''}`} to={process.env.PUBLIC_URL}>
                <Image attrImage={{ className: 'img-fluid for-light', src: logoWhite, alt: 'looginpage' }} />
                <Image attrImage={{ className: 'img-fluid for-dark', src: logoDark, alt: 'looginpage' }} />
              </Link>
            </div>
          
          
          <div className='login-main'>
          {!is2FARequired  && (
          <>
            {errMsg && <Alerts attrAlert={{ color: 'danger ' }} >
              <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
              </Alerts>}
          
            <Form className='theme-form login-form' onSubmit={handleSubmit}>
              <H4>Sign in to account ({process.env.REACT_APP_BASE_NAME})</H4>
              <P>Enter your email & password to login</P>
              <FormGroup>
                <Label className='col-form-label m-0' htmlFor="email">{EmailAddress}</Label>
                <Input className='form-control' type='email'  id='email'
                onChange={(e) => setEmail(e.target.value)} 
                value={email}
                ref={userRef}
                autoComplete="off" required/>
                
              </FormGroup>

              <FormGroup className='position-relative'>
                <Label className='col-form-label m-0' htmlFor="password">{Password}</Label>
                <div className='position-relative'>
                  <Input className='form-control' type={togglePassword ? 'text' : 'password'}
                    id='password'
                   onChange={(e) => setPassword(e.target.value)} value={password} />
                  <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
                    <span className={togglePassword ? '' : 'show'}></span>
                  </div>
                </div>
              </FormGroup>

              <FormGroup className='position-relative'>
                <div className='checkbox'>
                  <Input id='checkbox1' type='checkbox' />
                  <Label className='text-muted' for='checkbox1'>
                  {RememberPassword}
                  </Label>
                </div>
                <Link className='link' to={`/authentication/forget-password/${layoutURL}`}>
                  {ForgotPassword}
                </Link>
              </FormGroup>
              <FormGroup>
                <Btn attrBtn={{ color: 'primary', className: 'd-block w-100 mt-2' }}>
                  {isLoading ? <Spinner/> :  `${SignIn}`}
                </Btn>
              </FormGroup>
              <div className="persistCheck">
                    <input
                        type="hidden"
                        id="persist"
                        onChange={toggleCheck}
                        checked={check}
                    />
                    {/* <label htmlFor="persist">Trust This Device</label> */}
                </div>
            </Form>
            </>
          )}

          {(is2FARequired && !is2FAValidated) && 
          <TotpForm 
            onSubmit={handleCodeVerified} 
            useEmail={currentUser.email}
            displayImage={true} /> }
          </div>
         
        
        </div>
      </div>
    </Fragment>
  );
};

export default LoginForm;
